import { render, staticRenderFns } from "./SiftRadio.vue?vue&type=template&id=003ef8b3&scoped=true&"
import script from "./SiftRadio.vue?vue&type=script&lang=js&"
export * from "./SiftRadio.vue?vue&type=script&lang=js&"
import style0 from "./SiftRadio.vue?vue&type=style&index=0&id=003ef8b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ef8b3",
  null
  
)

export default component.exports